"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageCodes = void 0;
/**
 * List of all codes according to ISO639-1
 * https://www.loc.gov/standards/iso639-2/php/code_list.php
 */
var LanguageCodes;
(function (LanguageCodes) {
    LanguageCodes["en"] = "en";
    LanguageCodes["fr"] = "fr";
})(LanguageCodes = exports.LanguageCodes || (exports.LanguageCodes = {}));
//# sourceMappingURL=languageEnums.js.map